var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendMessageLeft = function SvgSendMessageLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m3.929 10.184 13.513-7.408a2.08 2.08 0 0 1 2.291.171c.675.514.973 1.347.779 2.174L19.122 11a.4.4 0 0 1-.391.308l-8.738-.038H9.99a.75.75 0 0 0-.003 1.5l8.754.039a.4.4 0 0 1 .388.308l1.383 5.845a2.1 2.1 0 0 1-.779 2.176c-.38.29-.826.436-1.274.436-.346 0-.694-.087-1.017-.264L3.93 13.901a2.09 2.09 0 0 1-1.1-1.859 2.09 2.09 0 0 1 1.1-1.858",
    clipRule: "evenodd"
  })));
};
export default SvgSendMessageLeft;